import {useState, useEffect} from 'react';
import {
  Form,
  Tab,
  Tabs,
  Table,
  Button} from 'react-bootstrap';
import {read, utils, write} from 'xlsx';
import FileSaver from 'file-saver';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';

import {useSelector} from 'react-redux';

export default function ModalSetSign(props) {
  const user = useSelector((state) => state.auth.currentUser);
  const [search3, setSearch3] = useState('');
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [step, setStep] = useState(1);
  const [error, setError] = useState('');
  const [key, setKey] = useState('signing');
  
  const [signing, setSigning] = useState({});

  const downloadXlsx = (input, name) => {
    try {
      const ws = utils.json_to_sheet(input);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'Sheet1');
      const wbout = write(wb, {
        bookType: 'xlsx',
        bookSST: false,
        type: 'array'
      });
      FileSaver.saveAs(
        new Blob([wbout], {type: 'application/octet-stream'}),
        `${name}.xlsx`
      );
    } catch (err) {
      console.error('export error', err);
    }
  };

  const onDelete = async (UPDATE_ON, EMPID) => {
    const TARGET = props.TARGET.filter((e) => e.EMPID !== EMPID);

    const input = {
      ...signing,
      UPDATE_ON: UPDATE_ON,
      TARGET: TARGET
    };

    console.log(input);
    await props.onUpdate(input);
  };

  const onUpdate = async (UPDATE_ON) => {
    const input = {
      ...signing,
      UPDATE_ON: UPDATE_ON,
    };
    console.log(input);

    await props.onUpdate(input);
    handleReupload();
  };

  const onUpdateOne = async (UPDATE_ON) => {
    const input = {
      ...signing,
      UPDATE_ON: UPDATE_ON,
      TARGET: [{EMPID: search3}]
    };
    await props.onUpdate(input);
    handleReupload();
    setSearch3('');
  };

  const handleReupload = async () => {
    setStep(1);
    setData([]);
  };

  function mapOrder(array, order) {
    array.sort(function (a, b) {
      var A = a['EMPID'],
        B = b['EMPID'];
      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });
    return array;
  }

  const fileUpload = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      let res1 = await validateFile(file);
      if (res1.length > 0) {
        let _res1 = await props.getFullData(res1);

        //เรียงตาม res1
        let item_order = res1.map((e) => `${e.EMPID}`);
        _res1 = mapOrder(_res1, item_order);

        setData(_res1);
        setSigning((prevState) => ({
          ...prevState,
          TARGET: _res1
        }));
        setStep(2);
      } else {
        toast.error('Wrong file format!');
      }
    }
    e.target.value = null;
  };

  const validateFile = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = utils.sheet_to_json(worksheet);
      console.log(jsonData);
      jsonData = jsonData.map((e, i) => ({
        ...e,
        index: i + 1
      }));
      if (!jsonData[0].hasOwnProperty('EMPID')) {
        throw 'error';
      }
      return jsonData;
    } catch {
      return [];
    }
  };

  useEffect(() => {
    console.log(props.item);
    setSigning(props.item);
  }, [props.item]);

  useEffect(() => {
    setSigning((prevState) => ({
      ...prevState,
      TARGET: props.TARGET
    }));
  }, [props.TARGET]);
  return (
    <div className="row">
      <div className="col-12 col-md-9">
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="signing" title="ข้อมูลเอกสาร (1)">
            <div className="row">
              <Form.Group className="mb-2 col-md-6">
                <Form.Label>หมายเลขเอกสาร</Form.Label>
                <Form.Control
                  type="text"
                  value={signing.TRAINING_ID}
                  placeholder={'หมายเลขเอกสาร'}
                  disabled={true}
                  // onChange={(e) => {
                  //   setSigning((prevState) => ({
                  //     ...prevState,
                  //     TRAINING_NAME: e.target.value
                  //   }));
                  // }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-6">
                <Form.Label>จัดทำโดย</Form.Label>
                <Form.Control
                  type="text"
                  value={signing.doc_by}
                  placeholder={'โดย'}
                  disabled={true}
                  // onChange={(e) => {
                  //   setTrainging((prevState) => ({
                  //     ...prevState,
                  //     TRAINING_GROUP_NAME: e.target.value
                  //   }));
                  // }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-12">
                <Form.Label>ชื่อเอกสาร</Form.Label>
                <Form.Control
                  as="textarea"
                  // type="text"
                  value={signing.doc_name_th}
                  placeholder={'ชื่อเอกสาร'}
                  // disabled={true}
                  onChange={(e) => {
                    setSigning((prevState) => ({
                      ...prevState,
                      doc_name_th: e.target.value
                    }));
                  }}
                />
              </Form.Group>
            </div>
            <Button
              // disabled={true}
              onClick={() => {
                onUpdate('MAIN');
              }}
              // className={
              //   props.showAdmin ||
              //   user.ID_EMP === props.item.BY_EMPID ||
              //   props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
              //     ? 'd-block'
              //     : 'd-none'
              // }
              className={'d-block'}
            >
              บันทึกแก้ไข
            </Button>
          </Tab>
          <Tab eventKey="target" title="กลุ่มเป้าหมาย (2)">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6">
                  <div className={'card card-success'}>
                    <div className="card-header">
                      <h3 className="card-title">รายชื่อปัจจุบัน</h3>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            downloadXlsx(props.TARGET, 'export');
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i className="fa fa-file-csv" />
                        </button>
                      </div>
                    </div>
                    <div
                      className={'card-body'}
                      style={{
                        height: '56vh',
                        width: '100%',
                        overflowY: 'scroll'
                      }}
                    >
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>รหัสพนักงาน</th>
                            <th>ชื่อ-สกุล</th>
                            <th>ลบ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.TARGET.map((x, i) => (
                            <tr key={`v-${i}`}>
                              <td>{i + 1}</td>
                              <td>{x['EMPID']}</td>
                              <td>{x['NAME']}</td>
                              <td>
                                <a>
                                  <i
                                    className="fas fa-trash"
                                    style={{cursor: 'pointer'}}
                                    onClick={(e) => {
                                      onDelete('TARGET', x.EMPID);
                                    }}
                                  />
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="row">
                        <input
                          value={search3}
                          type="text"
                          onChange={(event) => {
                            event.preventDefault();
                            setSearch3(event.target.value);
                          }}
                          className="form-control col-6 m-2"
                          placeholder="รหัสพนักงาน"
                        />
                        <Button
                          variant="info"
                          onClick={() => {
                            onUpdateOne('TARGETONE');
                          }}
                          // className={
                          //   props.showAdmin ||
                          //   user.ID_EMP === props.item.BY_EMPID ||
                          //   props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                          //     ? 'd-block m-2'
                          //     : 'd-none m-2'
                          // }
                          className={'d-block m-2'}
                        >
                          เพิ่ม 1 คน
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={
                      step === 1 ? 'card card-primary' : 'card collapsed-card'
                    }
                  >
                    <div className="card-header">
                      <h3 className="card-title">
                        ขั้นตอนที่ 1 : อัพโหลด Excel
                        (รายการเก่าจะหายและถูกแทนที่ด้วยของใหม่ทั้งหมด)
                      </h3>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            window
                              .open(
                                'https://api-passport.advanceagro.net/file/Training.xlsx',
                                '_blank'
                              )
                              ?.focus();
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i className="fa fa-file-csv" />
                        </button>
                      </div>
                    </div>
                    <div
                      className={step === 1 ? 'card-body' : 'card-body d-none'}
                    >
                      <Form.Group className="mb-3 col-md-9">
                        <Form.Control
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={fileUpload}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div
                    className={
                      step === 2 ? 'card card-primary' : 'card collapsed-card'
                    }
                  >
                    <div className="card-header">
                      <h3 className="card-title">
                        ขั้นตอนที่ 2 : ตรวจความถูกต้อง
                      </h3>
                    </div>
                    <div
                      className={step === 2 ? 'card-body' : 'card-body d-none'}
                      style={{
                        height: '56vh',
                        width: '100%',
                        overflowY: 'scroll'
                      }}
                    >
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>รหัสพนักงาน</th>
                            <th>ชื่อ-สกุล</th>
                            {/* <th>กลุ่ม</th>
                          <th>แผนก</th>
                          <th>บริษัท</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((x, i) => (
                            <tr key={`v-${i}`}>
                              <td>{i + 1}</td>
                              <td>{x['EMPID']}</td>
                              <td>{x['NAME']}</td>
                              {/* <td>{x['SECTION']}</td>
                            <td>{x['DEPARTMENT']}</td>
                            <td>{x['COMPANY']}</td> */}
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      <div className="row mt-2">
                        <Button
                          className="col-md-12"
                          variant="warning"
                          block
                          type="button"
                          onClick={handleReupload}
                        >
                          {'ไม่ถูกต้อง, อัพโหลดใหม่'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <Button
                disabled={data.length == 0}
                onClick={() => {
                  onUpdate('TARGET');
                }}
                // className={
                //   props.showAdmin ||
                //   user.ID_EMP === props.item.BY_EMPID ||
                //   props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                //     ? 'd-block'
                //     : 'd-none'
                // }
                className={'d-block'}
              >
                บันทึกแก้ไข
              </Button>
            </div>
          </Tab>
        </Tabs>
      </div>
      <p
        className="text-danger col-md-12 content"
        dangerouslySetInnerHTML={{__html: error}}
      ></p>
    </div>
  );
}
